import Handlebars from 'handlebars';

export const renderEmail = (template: string, data: Record<string, unknown>): string => {
	try {
		return Handlebars.compile(template || '')(data);
	} catch (error) {
		console.error('Failed to render email', error);
		return template || '';
	}
};
